var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllVenues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10V20.375C2.5 21.4796 3.39543 22.375 4.5 22.375H19.5C20.6046 22.375 21.5 21.4796 21.5 20.375V10",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21875 16.5C6.21875 15.1193 7.33804 14 8.71875 14V14C10.0995 14 11.2188 15.1193 11.2188 16.5V22.375H6.21875V16.5Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 8.5625C9.875 9.75336 8.90961 10.7187 7.71875 10.7187C6.52789 10.7187 5.5625 9.75336 5.5625 8.5625",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5625 8.5625C5.5625 9.75336 4.59711 10.7188 3.40625 10.7188C2.21539 10.7188 1.25 9.75336 1.25 8.5625V7.6604C1.25 7.47386 1.30218 7.29103 1.40064 7.13259L3.67532 3.47218C3.85779 3.17856 4.17898 3 4.52468 3H14.0938",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.5625C18.5 9.75336 19.4654 10.7188 20.6562 10.7188C21.8471 10.7188 22.8125 9.75336 22.8125 8.5625V7.6604C22.8125 7.47386 22.7603 7.29103 22.6619 7.13259L20.3872 3.47218C20.2047 3.17856 19.8835 3 19.5378 3H13.375",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 8.5625C14.1875 9.75336 13.2221 10.7187 12.0312 10.7187C10.8404 10.7187 9.875 9.75336 9.875 8.5625",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.5625C18.5 9.75336 17.5346 10.7187 16.3437 10.7187C15.1529 10.7187 14.1875 9.75336 14.1875 8.5625",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 1,
    transform: "matrix(-1 0 0 1 18.5 14.625)",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllVenues);
export default __webpack_public_path__ + "static/media/all-venues.42d6ae436921159253e54657136fdd32.svg";
export { ForwardRef as ReactComponent };